import React from "react";
import { useTranslation } from "react-i18next";
import analyticsService from "../../services/analyticsService";
import { buildSupportWhatsAppUrl } from "../../constants/support";
import SupportCallLink from "../ui/SupportCallLink";
import { APP_STORE_URL, PLAY_STORE_URL } from "../../constants/storeUrls";
import ScreenLayout from "../ui/ScreenLayout";
import Button from "../ui/Button";
import Icon from "../ui/Icon";

const appStoreUrl = () =>
  /android/i.test(navigator.userAgent || "") ? PLAY_STORE_URL : APP_STORE_URL;

// Écran 1g : la banque a refusé la préautorisation, rien n'est débité.
export default function CardRefusedScreen({ reason, station, connector, onRetry, onBack, panel }) {
  const { t } = useTranslation();
  const analyticsParams = { station_id: station, connector_id: connector, error_type: reason };

  return (
    <ScreenLayout onBack={onBack} panel={panel}>
      <div className="pt-6 md:pt-0" aria-live="assertive">
        <div className="h-16 w-16 rounded-full bg-qv-red-50 flex items-center justify-center">
          <Icon name="card-linear" size={30} className="text-qv-red md:h-8 md:w-8" />
        </div>
        <h1 className="mt-5 text-[26px] leading-[34px] tracking-[-.02em] font-bold md:text-[30px] md:leading-[38px]">
          {t("refused.title")}
        </h1>
        <p className="mt-1 text-sm font-semibold md:mt-1.5 md:font-medium md:text-qv-muted">{t("refused.subtitle")}</p>
        <p className="mt-4 text-[15px] leading-6 text-qv-muted">{t(`refused.${reason || "generic"}`)}</p>

        <div className="mt-6 flex flex-col gap-2.5 md:mt-7 md:grid md:grid-cols-2 md:gap-3">
          <Button className="md:!h-[52px] md:!text-[15px]" onClick={onRetry}>
            {t("refused.tryAnother")}
          </Button>
          <Button
            variant="secondary"
            className="md:!px-2 md:text-center"
            href={appStoreUrl()}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => analyticsService.pushEvent("app_download_tapped", { context: "card_refused" })}
          >
            {t("refused.useApp")}
          </Button>
        </div>

        <div className="mt-6 flex flex-col items-center gap-2.5 md:mt-7 md:flex-row md:flex-wrap md:items-center md:gap-4 md:border-t md:border-[#F0F0F2] md:pt-6">
          <p className="text-sm font-medium text-qv-muted md:flex-1">{t("refused.needHelp")}</p>
          <Button
            variant="whatsapp"
            icon="whatsapp"
            className="md:!w-auto md:!px-5"
            href={buildSupportWhatsAppUrl(t, { station, connector })}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => analyticsService.pushEvent("support_whatsapp_clicked", analyticsParams)}
          >
            {t("support.whatsapp")}
          </Button>
          <SupportCallLink analyticsParams={analyticsParams} className="md:basis-full" />
        </div>
      </div>
    </ScreenLayout>
  );
}
